import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/ThemePark/reports/QueueReport/QueueReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class QueueReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/ThemePark/reports/QueueReport/QueueReport")
	}

	render() {
		return (
			<Activity 
				name="QueueReport"
				RenderedComponent={this.RenderedComponent}
				context="QueueReport"
				action="QueueReport"
				formActions={FormAction}/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(QueueReportActivity)